import { TaskItem } from '../../../../types/topic';

// TaskStatus is now a string (not limited to enum)
export type TaskStatus = string;

export interface TaskDragData {
  id: string;
  status: TaskItem['status'];
  index: number;
}

// For column dragging
export interface ColumnDragData {
  id: string;
  index: number;
}

export interface SensorContext {
  items: Record<string, { id: string; index: number; data: TaskItem }>;
  containers: Record<string, TaskItem['status']>;
}

// Type IDs for dnd-kit
export const Types = {
  TASK: 'task',
  COLUMN: 'column',
};
